import axios from 'axios';

export const CompanyApi = {
    list: () => axios.get('/web/companies/'),
    create: (companyData) => axios.post('/web/companies/', companyData),
    update: (id, companyData) => axios.put(`/web/companies/${id}/`, companyData)
};
